export default "__VITE_ASSET__e6b788a8__"